<script setup lang="ts">
import formatBytes from "@/helpers/files/formatBytes";
import type { IFileState } from "@/interfaces";

interface Props {
  file: IFileState;
  customStyles?: string;
}

withDefaults(defineProps<Props>(), {
  customStyles: "min-w-160 w-160 h-160 min-h-160 rounded-2xl",
});
</script>

<template>
  <a
    :href="file.url"
    target="_blank"
    :class="[
      'overflow-hidden block px-4 bg-neutral100',
      customStyles,
      'group/pdf',
      'focus-visible-strong',
    ]"
  >
    <div
      class="flex flex-col items-center justify-center gap-1 w-full h-full group-hover/pdf:scale-105 transition-transform"
    >
      <i class="far fa-file-pdf text-3xl text-neutral1000"></i>
      <div v-if="file.name" class="b300 text-neutral1000 truncate">
        {{ file.name }}
      </div>
      <div v-if="file.size" class="b300 text-neutral700 truncate">
        {{ formatBytes(file.size) }}
      </div>
    </div>
  </a>
</template>
